import Hayabusa from "../images/cars-big/hayabusa.png";
import Ducati_V4 from "../images/cars-big/ducati-v4.png";
import Duke_200 from "../images/cars-big/duke200.png";
import Daytona_675R from "../images/cars-big/daytona-675-r.png";
import MV_Agusta_F3 from "../images/cars-big/mv-agusta-f3.png";
import Yamaha_MT_125 from "../images/cars-big/mt-125.png";

export const CAR_DATA = [
    [
        {
            name: "Suzuki Hayabusa",
            price:  "9999",
            img: Hayabusa,
            mark: "Suzuki",
            year: "1999",
            engine: "1300 cc",
            fuel_tank: "21 L",
            top_speed: "299 km/h",
            horsepower: "190 hp",
        },
    ],
    [
        {
            name: "Ducati Panigale V4",
            price:  "11999",
            img: Ducati_V4,
            mark: "Ducati",
            year: "2018",
            engine: "1103 cc",
            fuel_tank: "17 L",
            top_speed: "299 km/h",
            horsepower: "215.5 hp",
        },
    ],
    [
        {
            name: "KTM 200 Duke",
            price:  "1499",
            img: Duke_200,
            mark: "KTM",
            year: "2012",
            engine: "200 cc",
            fuel_tank: "13.4 L",
            top_speed: "142 km/h",
            horsepower: "25 hp",
        },
    ],
    [
        {
            name: "Triumph Daytona 675R",
            price:  "10999",
            img: Daytona_675R,
            mark: "Triumph",
            year: "2013",
            engine: "675 cc",
            fuel_tank: "17.4 L",
            top_speed: "265 km/h",
            horsepower: "116 hp",
        },
    ],
    [
        {
            name: "MV Agusta F3 800",
            price:  "8499",
            img: MV_Agusta_F3,
            mark: "MV Agusta",
            year: "2012",
            engine: "798 cc",
            fuel_tank: "16.5 L",
            top_speed: "251 km/h",
            horsepower: "148 hp",
        },
    ],
    [
        {
            name: "Yamaha MT-125",
            price:  "4599",
            img: Yamaha_MT_125,
            mark: "Yamaha",
            year: "2014",
            engine: "125 cc",
            fuel_tank: "10 L",
            top_speed: "125 km/h",
            horsepower: "15 hp",
        },
    ],
]